import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSEO } from "@/hooks/useSEO";
import { getHot } from "@/utils/movie";
import MovieCard from "@/components/feature/MovieCard";

export default function NotFound() {
  const location = useLocation();
  const hot = getHot(4);

  useSEO({
    title: "页面未找到 - 欧美一级视频",
    description: "抱歉，你访问的页面不存在。返回首页继续浏览欧美电影与电视剧精选资源。",
    keywords: "404,页面未找到,欧美一级视频",
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="flex flex-1 items-center justify-center">
        <div className="mx-auto w-full max-w-7xl px-4 py-16 text-center md:px-6">
          <span className="font-label text-[100px] font-black leading-none text-primary-100 md:text-[160px]">
            404
          </span>
          <div className="-mt-6 flex flex-col items-center gap-4 md:-mt-10">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-emotion-sad-line text-3xl"></i>
            </span>
            <h1 className="text-2xl font-black text-foreground-950 md:text-3xl">页面未找到</h1>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              抱歉，你访问的页面不存在或已被移除。请检查地址是否正确，或返回首页继续浏览。
            </p>
            <p className="font-label text-xs text-foreground-400">{location.pathname}</p>
            <div className="mt-2 flex flex-wrap justify-center gap-3">
              <Link
                to="/"
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600"
              >
                <i className="ri-home-4-line"></i>
                返回首页
              </Link>
              <Link
                to="/category/movie"
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-600 hover:bg-primary-50"
              >
                <i className="ri-film-line"></i>
                浏览影视分类
              </Link>
            </div>
          </div>

          <div className="mt-14">
            <h2 className="mb-4 text-lg font-bold text-foreground-950">你可能感兴趣的内容</h2>
            <div className="mx-auto grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
              {hot.map((m) => (
                <MovieCard key={m.id} movie={m} />
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}